import { createContext, type ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';
import { useMediaQuery } from '../lib/hooks';

/** The phone top bar's middle slot (between the logo and the bell), set by the AppShell. */
export const TopbarSlotContext = createContext<HTMLElement | null>(null);

/**
 * Renders its children in the phone top bar, between the logo and the bell. Wider screens have
 * no top bar, so the children stay where the page put them.
 */
export function TopbarSlot({ children }: { children: ReactNode }) {
  const slot = useContext(TopbarSlotContext);
  const phone = useMediaQuery('(max-width: 599px)');
  return phone && slot ? createPortal(children, slot) : <>{children}</>;
}
